import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { showAlertServiceError } from "utils/alerts";
import { enumLevelTrd, HttpStatus } from "utils/enums";
import { reStructureData } from "utils/reStructureData";
import { isNullOrUndefined } from "utils/validations";
import { enumsPermissionsTrdLevels, timeoutLength } from "utils/enums";
import { initialPaginationStandart } from "utils/initialPaginationsConfig";
import { useTranslation } from "react-i18next";
import useRoles from "hooks/useRoles";
import useTrd from "hooks/useTrd";
import swal from "sweetalert";

const TrdContext = React.createContext(undefined);
export function TrdContextProvider({ children }) {
  const { t } = useTranslation();
  const [hasFiles, setHasFiles] = useState(false);
  const {
    getTreeByDomain,
    getTreeByDomainRoles,
    getTreeExpedientByDomain,
    getTreeExpedientByDomainRoles,
    getExpedients,
    getExpedientsRoles,
    getSerieSubserieStructure,
    getPathSetExpedient,
  } = useTrd();
  const { levelsTrdPermissions } = useRoles();
  const [showOrdenation, setShowOrdenation] = useState(false);
  const [seieSubserieId, setSeieSubserieId] = useState("");
  const [seieSubserieBackgroundId, setSeieSubserieBackgroundId] = useState("");
  const [subDivisionId, setSubDivisionId] = useState("");
  const [isStructure, setIsStructure] = useState(false);
  const [validateField, setValidateField] = useState(true);
  const [recordShowExpTree, setRecordShowExpTree] = useState(false);
  const [levelFolder, setLevelFolder] = useState(0);
  const [showFormConditional, setShowFormConditional] = useState(false);
  const [showRightPanel, setShowRightPanel] = useState(false);
  const [showRightPanelTreeExpedients, setShowRightPanelTreeExpedients] = useState(false);
  const [showFolderCondition, setShowFolderCondition] = useState(false);
  const [showDirectoryCondition, setShowDirectoryCondition] = useState(false);
  const [showCreateExpedientForm, setShowCreateExpedientForm] = useState(false);
  const [showCreateSubDivisonForm, setShowCreateSubDivisonForm] = useState(false);
  const [showEditSubDivisonForm, setShowEditSubDivisonForm] = useState(false);
  const [showEditDirectoryForm, setShowEditDirectoryForm] = useState(false);
  const [showEditSectionForm, setShowEditSectionForm] = useState(false);
  const [showCreateSection, setShowCreateSection] = useState(false);
  const [showEditSerieForm, setShowEditSerieForm] = useState(false);
  const [showEditSubSerieForm, setShowEditSubSerieForm] = useState(false);
  const [showEditSubSectionForm, setShowEditSubSectionForm] = useState(false);
  const [showEditBackground, setShowEditBackground] = useState(false);
  const [showEditSection, setShowEditSection] = useState(false);
  const [editDirectory, setEditDirectory] = useState(false);
  const [option, setOption] = useState(true);
  const [openOptions, setOpenOptions] = useState(false);
  const [optionDir, setOptionDir] = useState(true);
  const [optionDisabled, setOptionDisabled] = useState(false);
  const [optionEdit, setOptionEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCreateDirectoryForm, setShowCreateDirectoryForm] = useState(false);
  const [isCreateExpedient, setIsCreateExpedient] = useState(false);
  const [showExpedientTree, setShowExpedientTree] = useState(false);
  const [selectLevel, setSelectLevel] = useState(0);
  const [expedientParent, setExpedientParent] = useState("");
  const [fundName, setFundName] = useState("");
  const [expedientName, setExpedientName] = useState("");
  const [folderName, setFolderName] = useState("");
  const [structureTrd, setStructureTrd] = useState([]);
  const [structureTrdExpedient, setStructureTrdExpedient] = useState({
    data: [],
    requires_permission_review: false,
  });
  const [structureTrdSeriesSubseries, setStructureTrdSeriesSubseries] = useState([]);
  const [currentLevelSelected, setCurrentLevelSelected] = useState(0);
  const [isByRecord, setIsByRecord] = useState(false);
  const [submitByRecord, setSubmitByRecord] = useState(false);
  const [listExpedients, setListExpedients] = useState([]);
  const [nodataMessage, setNodataMessage] = useState(t("tableRowsEmpty"));
  const [totalPages, setTotalPages] = useState(0);
  const [loadingExpedientList, setLoadingExpedientList] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [errorCharacters, setErrorCharacters] = useState("");
  const [status, setStatus] = useState();
  const [parentData, setParentData] = useState({
    id: 0,
    level: enumLevelTrd.BACKGROUND,
  });
  const [trdForm, setTrdForm] = useState({
    name: "",
    code: "",
    level: enumLevelTrd.SECTION,
  });
  const [createExpedientForm, setCreateExpedientForm] = useState({
    name: "",
    subject: "",
    status: 1,
    level: enumLevelTrd.EXPEDIENT,
  });
  const [createSubDivisionForm, setCreateSubDivisionForm] = useState({
    name: "",
    level: enumLevelTrd.SUBDIVISION,
  });
  const [createSubDivisionFormSTR, setCreateSubDivisionFormSTR] = useState({
    subdivision_struct: [""],
    level: enumLevelTrd.SUBDIVISION,
  });
  const [editSubDivisionForm, setEditSubDivisionForm] = useState({
    name: "",
  });
  const [editSubDivisionFormSTR, setEditSubDivisionFormSTR] = useState({
    base_subdivision_uuid: "",
    name: "",
  });
  const [createDirectoryFormSTR, setCreateDirectoryFormSTR] = useState({
    serie_subserie_uuid: "",
    directory_struct: [""],
    level: enumLevelTrd.DIRECTORY,
  });
  const [createDirectoryForm, setCreateDirectoryForm] = useState({
    name: "",
    level: enumLevelTrd.DIRECTORY,
  });
  const [editDirectoryFormSTR, setEditDirectoryFormSTR] = useState({
    base_subdivision_uuid: "",
    base_directory_uuid: "",
    name: "",
  });
  const [editDirectoryForm, setEditDirectoryForm] = useState({
    name: "",
  });
  const [editSectionFormService, setEditSectionFormService] = useState({
    name: "",
    code: "",
    parent_id: "",
  });
  const [editBackground, setEditBackground] = useState({
    name: "",
  });
  const [editSubSectionFormService, setEditSubSectionFormService] = useState({
    name: "",
    code: "",
    parent_id: "",
    background_parent_id: "",
  });
  const [foldersId, setFoldersId] = useState({
    backgroundId: "",
    sectionId: "",
    subSectionId: "",
    serieId: "",
    subSerieId: "",
    expedientId: "",
    subDivisionId: "",
    subDirectoryId: "",
  });
  const [editSerieFormService, setEditSerieFormService] = useState({
    name: "",
    code: "",
    parent_id: "",
    background_parent_id: "",
  });
  const [hasSubseries, setHasSubseries] = useState(false);
  const [hasExpedients, setHasExpedients] = useState(false);
  const [expedientParentByPath, setExpedientParentByPath] = useState(null);
  const [foldersIdByPath, setFoldersIdByPath] = useState({
    backgroundId: "",
  });
  const [refreshDataExpedient, setRefreshDataExpedient] = useState(false);
  const [paginationRecordList, setPaginationRecordList] = useState(initialPaginationStandart);
  const [hasExpedientFixedPath, sethasExpedientFixedPath] = useState(false);
  const [expedientSetPath, setExpedientSetPath] = useState({});
  const [expedientFixedUuid, setExpedientFixedUuid] = useState("");
  const [isLoadingExpedietnPath, setIsLoadingExpedietnPath] = useState(false);
  const [expedientPathSet, setExpedientPathSet] = useState({
    form_uuid: "",
    record_uuid: "",
    serie_subserie_uuid: "",
  });
  const [isLoadingOrdination, setIsLoadingOrdination] = useState(false);
  const [hasOrdination, setHasOrdination] = useState(false);
  const [expedientStatus, setExpedientStatus] = useState();
  const [backgroundUuid, setBackgroundUuid] = useState("");
  const [codeAlowedLevelsPermissions, setCodeAlowedLevelsPermissions] = useState(0);
  const [codeAlowedExpedientLevelsPermissions, setCodeAlowedExpedientLevelsPermissions] =
    useState(0);
  const [codeAlowedOrdinationLevelsPermissions, setCodeAlowedOrdinationLevelsPermissions] =
    useState(0);
  const [dropdownPermissionsOpen, setDropdownPermissionsOpen] = useState(false);
  const [levelTrdPermissions, setLevelTrdPermissions] = useState([]);
  const [temporalLevelTrdPermissions, setTemporalLevelTrdPermissions] = useState([]);
  const [toastlevelsTrd, setToastlevelsTrd] = useState({ visible: false, message: "", color: "" });
  const [isLoadingAddLevelsPermissions, setIsLoadingAddLevelsPermissions] = useState(false);
  const [isFinishExpedientConfig, setIsFinishExpedientConfig] = useState(false);
  const [levelPermisionState, setLevelPermissionState] = useState({
    level_uuid: "",
    level: 0,
    background_uuid: "",
    permissions: [],
  });
  const [temporalLevelPermisionState, setTemporalLevelPermissionState] = useState({
    level_name: "",
    level_uuid: "",
    permissions: [],
  });

  /**
   * Sets a toast message with the provided message and color,
   * then hides the toast message after a specified time.
   * @param {string} message - The message to be displayed in the toast.
   * @param {string} color - The color of the toast message.
   */
  const showToastPermissions = (message, color) => {
    setToastlevelsTrd({ visible: true, message, color });
    setTimeout(
      () => setToastlevelsTrd({ visible: false, message: "", color: "" }),
      timeoutLength.MIN_LENGTH_TIME,
    );
  };

  /**
   * Toggles the visibility of the permissions dropdown.
   * @param {Event} eventAssing - The event object to stop propagation.
   */
  const toggleDropdownPermissions = (eventAssing) => {
    eventAssing.stopPropagation();
    setDropdownPermissionsOpen((prevState) => !prevState);
  };

  /**
   * Handles the change in level permissions based on the event, node, and permission value.
   * Updates the permissions for the level and sets the state accordingly.
   * @param {Event} eventChange - The event triggering the permission change.
   * @param {Node} node - The node for which permissions are being updated.
   * @param {string} permissionValue - The value of the permission being updated.
   */
  const handleOnChangeLevelPermissions = (eventChange, node, permissionValue) => {
    const { checked } = eventChange.target;
    eventChange.stopPropagation();
    const updatedPermissions = [...levelPermisionState.permissions];

    if (checked !== false) {
      if (updatedPermissions.includes(permissionValue) === false) {
        updatedPermissions.push(permissionValue);
      }
    } else {
      const index = updatedPermissions.indexOf(permissionValue);
      if (index !== -1) {
        updatedPermissions.splice(index, 1);
      }
    }

    setLevelPermissionState({
      ...levelPermisionState,
      level_uuid: node.id,
      level: node.level,
      background_uuid: backgroundUuid,
      permissions: updatedPermissions,
    });

    setTemporalLevelPermissionState({
      ...temporalLevelPermisionState,
      level_name: node.name,
      level_uuid: node.id,
      permissions: updatedPermissions,
    });
  };

  /**
   * Handles the addition of level permissions based on the current state.
   * Validates the permissions and updates the existing permissions if necessary.
   * Shows toast messages for different validation scenarios.
   * @param {Object} levelPermisionState - The current state of level permissions.
   * @param {Array} levelTrdPermissions - The list of existing TRD permissions.
   * @param {Array} temporalLevelTrdPermissions - The list of temporary TRD permissions.
   * @param {Function} setLevelPermissionState - Function to set the level permission state.
   * @param {Function} setDropdownPermissionsOpen - Function to toggle the dropdown permissions open state.
   */
  const handleAddLevelPermissions = () => {
    const { permissions } = levelPermisionState;
    const newPermission = { ...levelPermisionState };
    const newPermissionTemp = { ...temporalLevelPermisionState };
    const existingPermission = levelTrdPermissions.find(
      (perm) => perm.level_uuid === newPermission.level_uuid,
    );

    if (permissions.length === 0) {
      showToastPermissions(t("createRoles.temporalPermissionLevelValidation1"), "info");
      return;
    }

    if (existingPermission) {
      const alreadyHasConsult = existingPermission.permissions.includes(
        enumsPermissionsTrdLevels.CONSULT_FILES,
      );
      const alreadyHasUpload = existingPermission.permissions.includes(
        enumsPermissionsTrdLevels.UPLOAD_FILES,
      );

      if (alreadyHasConsult === true && alreadyHasUpload === true) {
        showToastPermissions(t("createRoles.temporalPermissionLevelValidation2"), "info");
        setLevelPermissionState({
          ...levelPermisionState,
          permissions: [],
        });
        setDropdownPermissionsOpen((prevState) => !prevState);
        return;
      }

      if (
        newPermission.permissions.includes(enumsPermissionsTrdLevels.CONSULT_FILES) &&
        alreadyHasConsult === false
      ) {
        existingPermission.permissions.push(enumsPermissionsTrdLevels.CONSULT_FILES);
      } else if (
        newPermission.permissions.includes(enumsPermissionsTrdLevels.CONSULT_FILES) &&
        alreadyHasConsult === true
      ) {
        showToastPermissions(t("createRoles.temporalPermissionLevelValidation3"), "info");
        setLevelPermissionState({
          ...levelPermisionState,
          permissions: [],
        });
        setDropdownPermissionsOpen((prevState) => !prevState);
      }

      if (
        newPermission.permissions.includes(enumsPermissionsTrdLevels.UPLOAD_FILES) &&
        alreadyHasUpload === false
      ) {
        existingPermission.permissions.push(enumsPermissionsTrdLevels.UPLOAD_FILES);
      } else if (
        newPermission.permissions.includes(enumsPermissionsTrdLevels.UPLOAD_FILES) &&
        alreadyHasUpload === true
      ) {
        showToastPermissions(t("createRoles.temporalPermissionLevelValidation4"), "info");
        setLevelPermissionState({
          ...levelPermisionState,
          permissions: [],
        });
        setDropdownPermissionsOpen((prevState) => !prevState);
      }

      setLevelTrdPermissions([...levelTrdPermissions]);
      setTemporalLevelTrdPermissions([...temporalLevelTrdPermissions]);
    } else {
      setLevelTrdPermissions((prevPermissions) => [...prevPermissions, newPermission]);
      setTemporalLevelTrdPermissions((prevPermissions) => [...prevPermissions, newPermissionTemp]);
    }

    setLevelPermissionState({
      level_uuid: "",
      level: 0,
      background_uuid: "",
      permissions: [],
    });
    setTemporalLevelPermissionState({
      level_name: "",
      level_uuid: "",
      permissions: [],
    });

    setDropdownPermissionsOpen((prevState) => !prevState);
  };

  /**
   * Handles the removal of permissions associated with a specific level UUID.
   * Removes the permissions from both the main level permissions list and the temporal level permissions list.
   * @param {string} level_uuid - The UUID of the level for which permissions need to be removed.
   */
  const handleRemoveLevelPermissions = (level_uuid) => {
    const updatedLevelTrdPermissions = levelTrdPermissions.filter(
      (perm) => perm.level_uuid !== level_uuid,
    );
    const updatedTemporalLevelTrdPermissions = temporalLevelTrdPermissions.filter(
      (perm) => perm.level_uuid !== level_uuid,
    );
    setLevelTrdPermissions(updatedLevelTrdPermissions);
    setTemporalLevelTrdPermissions(updatedTemporalLevelTrdPermissions);
  };

  /**
   * Returns an object containing the levels_trd_permissions property.
   */
  const getLevelsTrdPermissionsObject = () => {
    return {
      levels_trd_permissions: levelTrdPermissions,
    };
  };

  /**
   * Handles the submission of levels permissions for a specific role.
   * @param {string} rolUuid - The UUID of the role to add permissions to.
   */
  const handleOnSubmitLevelsPermissions = (rolUuid) => {
    const levelsTrdPermissionsObject = getLevelsTrdPermissionsObject();
    setIsLoadingAddLevelsPermissions(true);
    levelsTrdPermissions(rolUuid, levelsTrdPermissionsObject)
      .then((response) => {
        if (response.status === 201) {
          swal({
            title: t("modal.DoneError.header"),
            text: t("createRoles.permissionsAddedSuccessfully"),
            icon: "success",
            button: t("modal.Done.footerButton"),
          }).then(() => {
            setIsFinishExpedientConfig(true);
          });
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        let levelUuid;

        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }

        if (isNullOrUndefined(error.response) === false) {
          if (error.response.data.code === "10064") {
            levelUuid = error.response.data.data;
            const levelItem = temporalLevelTrdPermissions.find(
              (item) => item.level_uuid === levelUuid,
            );
            if (isNullOrUndefined(levelItem) === false) {
              const levelName = `<li key=${levelItem.level_uuid}><em>${levelItem.level_name}</em></li>`;
              return swal({
                title: t("modal.DoneError.header"),
                text: t("createRoles.ErrorPermissions"),
                content: {
                  element: "div",
                  attributes: {
                    innerHTML: `<ul>${levelName}</ul>`,
                    className: "custom-content-class",
                  },
                },
                icon: "error",
                dangerMode: true,
                button: t("modal.Done.footerButton"),
              }).then((willClose) => {
                if (willClose) {
                  const updatedTemporalLevelTrdPermissions = temporalLevelTrdPermissions.filter(
                    (item) => item.level_uuid !== levelUuid,
                  );
                  const updatedLevelTrdPermissions = levelTrdPermissions.filter(
                    (item) => item.level_uuid !== levelUuid,
                  );

                  setTemporalLevelTrdPermissions(updatedTemporalLevelTrdPermissions);
                  setLevelTrdPermissions(updatedLevelTrdPermissions);
                }
              });
            } else {
              return null;
            }
          }
        }
      })
      .finally(() => {
        setIsLoadingAddLevelsPermissions(false);
      });
  };

  const validateSerieinSubserie = (level, id) => {
    let isCreate = false;
    const validateSection = structureTrd.some((structure) => structure.parentId === id);

    if (level === enumLevelTrd.SUBSECTION || level === enumLevelTrd.SECTION) {
      isCreate = false;
      setIsCreateExpedient(false);
      return;
    }

    if (level === enumLevelTrd.SUBSERIE) {
      setTrdForm({
        ...trdForm,
        level: enumLevelTrd.SUBSERIE,
      });
      setIsCreateExpedient(false);
      isCreate = true;
      return isCreate;
    } else if (validateSection) {
      setIsCreateExpedient(false);
      isCreate = false;
    } else {
      isCreate = true;
      setIsCreateExpedient(true);
    }
    return isCreate;
  };

  /**
   * Fetches and processes a paginated list of expedients based on the provided search criteria.
   * This function sets the loading state, retrieves the expedients based on pagination and search criteria,
   * updates the state with the fetched data, and handles cases where no data is found or an error occurs.
   * @param {number} page - The current page number for pagination.
   * @param {number} per_page - The number of expedients to fetch per page.
   * @param {string} id - The ID associated with the search (e.g., user or domain ID).
   * @param {string} backgroundId - The ID of the background to filter the expedients.
   * @param {string} searchData - The search query to filter expedients.
   * @param {string} status - The status filter for the expedients.
   * @returns {void} This function does not return a value.
   */
  const getExpedientsBySearch = useCallback(
    (page, per_page, id, backgroundId, searchData, status) => {
      setLoadingExpedientList(true);
      getExpedients(page, per_page, id, backgroundId, searchData, status)
        .then((response) => {
          const dataResponse = response.data;
          if (isNullOrUndefined(dataResponse) === false) {
            setListExpedients(dataResponse.items);
            setTotalPages(dataResponse.pages);
            if (searchData !== "" && dataResponse.items.length === 0) {
              setNodataMessage(t("lookupFilterMessageEmpty"));
            }
          } else {
            showAlertServiceError();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
            return;
          }
        })
        .finally(() => {
          setLoadingExpedientList(false);
        });
    },
    [],
  );

  /**
   * Fetches expedients based on search criteria and user roles.
   * @param {number} page - The page number for pagination.
   * @param {number} per_page - The number of items per page.
   * @param {number} id - The user ID.
   * @param {string} backgroundId - The background ID.
   * @param {string} searchData - The search data.
   * @param {number} status - The status of the expedients.
   */
  const getExpedientsBySearchRoles = useCallback(
    (page, per_page, id, backgroundId, searchData, action, status) => {
      setLoadingExpedientList(true);
      getExpedientsRoles(page, per_page, id, backgroundId, searchData, action, status)
        .then((response) => {
          if (isNullOrUndefined(response) === false) {
            const dataResponse = response.data;
            setListExpedients(dataResponse.items);
            setCodeAlowedExpedientLevelsPermissions(response.code);
            setTotalPages(dataResponse.pages);
            if (searchData !== "" && dataResponse.items.length === 0) {
              setNodataMessage(t("lookupFilterMessageEmpty"));
            }
          } else {
            showAlertServiceError();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
            return;
          }
        })
        .finally(() => {
          setLoadingExpedientList(false);
        });
    },
    [],
  );

  /**
   * Fetches and processes the tree structure for the current domain.
   * This function sets the loading state, retrieves the tree structure, processes it, and updates
   * the state with the restructured data.p
   * @returns {void} This function does not return a value.
   */
  const getTreeByDomainCallback = useCallback(() => {
    setIsLoading(true);
    getTreeByDomain()
      .then((response) => {
        if (response.status === 200) {
          setStructureTrd(reStructureData(response.data.data));
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
        setStructureTrd([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  /**
   * Fetches the tree structure based on a given domain and action, processes the response, and updates the state accordingly.
   * The function sets a loading state while making the request via `getTreeByDomainCloned`, processes the response if successful,
   * restructures the data, and updates the state. If there is an error or unsuccessful status, it handles the error by showing an alert or clearing the tree structure.
   * @param {object} action - The action object used to request the tree structure for a specific domain.
   * @returns {void}
   */
  const getTreeByDomainCallbackRoles = useCallback((action) => {
    setIsLoading(true);
    getTreeByDomainRoles(action)
      .then((response) => {
        if (response.status === 200) {
          setCodeAlowedLevelsPermissions(response.data.code);
          setStructureTrd(reStructureData(response.data.data));
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
        setStructureTrd([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  /**
   * Fetches and processes the expedient tree structure based on the provided background and expedient IDs.
   * This function sets the loading state, retrieves the expedient tree structure, processes it, and updates
   * the state with the restructured data. It also determines if ordination is present and updates the expedient status.
   * @param {string} backgroundId - The ID of the background for which the expedient tree structure is being fetched.
   * @param {string} expedientId - The ID of the expedient to fetch the tree structure for.
   * @returns {void} This function does not return a value.
   */
  const getTreeExpedientByDomainCallback = useCallback((backgroundId, expedientId) => {
    setIsLoadingOrdination(true);
    getTreeExpedientByDomain(backgroundId, expedientId)
      .then((response) => {
        if (response.status === 200) {
          const ordinationStricture = response.data.data;
          const newStructureData = {
            data: reStructureData(ordinationStricture),
            requires_permission_review: response.data.requires_permission_review || false,
            code: response.data.code,
          };
          setStructureTrdExpedient(newStructureData);
          const hasOrdenationTemp = ordinationStricture.some(
            (element) =>
              element.level === enumLevelTrd.SUBDIVISION ||
              element.level === enumLevelTrd.DIRECTORY,
          );
          const expedientStatus = ordinationStricture.find(
            (element) => element.level === enumLevelTrd.EXPEDIENT,
          );
          setExpedientStatus(expedientStatus.status);
          setHasOrdination(hasOrdenationTemp);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
        setStructureTrdExpedient({ data: [], requires_permission_review: false });
      })
      .finally(() => {
        setShowExpedientTree(true);
        setIsLoadingOrdination(false);
      });
  }, []);

  /**
   * Callback function to fetch tree expedient data based on domain roles.
   * @param {string} backgroundId - The ID of the background.
   * @param {string} expedientId - The ID of the expedient.
   * @param {string} action - The action to be performed.
   */
  const getTreeExpedientByDomainCallbackRoles = useCallback((backgroundId, expedientId, action) => {
    setIsLoadingOrdination(true);
    getTreeExpedientByDomainRoles(backgroundId, expedientId, action)
      .then((response) => {
        if (response.status === 200) {
          const fullResponseData = response.data;
          const ordinationStricture = fullResponseData.data;
          const anyRequiresReview = ordinationStricture.some(
            (item) => item.requires_permission_review === true,
          );
          const newStructureData = {
            data: reStructureData(ordinationStricture),
            requires_permission_review: anyRequiresReview,
            code: fullResponseData.code,
          };
          setStructureTrdExpedient(newStructureData);
          setCodeAlowedOrdinationLevelsPermissions(fullResponseData.code);
          const hasOrdenationTemp = ordinationStricture.some(
            (element) =>
              element.level === enumLevelTrd.SUBDIVISION ||
              element.level === enumLevelTrd.DIRECTORY,
          );
          const expedientStatus = ordinationStricture.find(
            (element) => element.level === enumLevelTrd.EXPEDIENT,
          );
          setExpedientStatus(expedientStatus.status);
          setHasOrdination(hasOrdenationTemp);
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
        setStructureTrdExpedient({ data: [], requires_permission_review: false });
      })
      .finally(() => {
        setShowExpedientTree(true);
        setIsLoadingOrdination(false);
      });
  }, []);

  /**
   * Fetches and processes the structure of series and subseries based on the provided background and series/subseries IDs.
   * This function sets the loading state, retrieves the series and subseries structure, sorts it, processes it,
   * and updates the state with the restructured data.
   * @param {string} backgroundId - The ID of the background for which the series and subseries structure is being fetched.
   * @param {string} serieSubserieId - The ID of the series or subseries to fetch the structure for.
   * @returns {void} This function does not return a value.
   */
  const getSeriesSubseriesStructure = useCallback((backgroundId, serieSubserieId) => {
    setIsLoading(true);
    getSerieSubserieStructure(backgroundId, serieSubserieId)
      .then((response) => {
        let respStructure = response.data.data;
        if (isNullOrUndefined(respStructure) === false) {
          let newRespStructure = respStructure.sort((firsNode, secondNode) =>
            ("" + firsNode.name).localeCompare(secondNode.name, undefined, { numeric: true }),
          );
          if (response.status === 200) {
            setStructureTrdSeriesSubseries(reStructureData(newRespStructure));
          }
        } else {
          showAlertServiceError();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
        setStructureTrdSeriesSubseries([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  /**
   * Fetches the expedient structure based on the provided record UUID and updates the relevant state.
   * This function sets the loading state, makes an asynchronous call to retrieve the expedient path,
   * and updates state variables based on the response.
   * @param {string} recordUuid - The UUID of the record for which the expedient structure is being fetched
   * @returns {void} This function does not return a value.
   */
  const getHasExpedientStructure = useCallback((recordUuid) => {
    setIsLoadingExpedietnPath(true);
    getPathSetExpedient(recordUuid)
      .then((response) => {
        if (isNullOrUndefined(response.data) === false) {
          const infoParentPath = response.data;
          if (Object.keys(infoParentPath.path).length > 0) {
            sethasExpedientFixedPath(true);
            setExpedientFixedUuid(infoParentPath.expedient_uuid);
            setExpedientSetPath(infoParentPath.path);
          }
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      })
      .finally(() => {
        setIsLoadingExpedietnPath(false);
      });
  }, []);

  /**
   * Validates the deletion of a list of forms and displays an error message if certain conditions are met.
   * @param {Array<Object>} forms - An array of form objects to be validated. Each form object should have a `name` property.
   * @returns {void} This function does not return a value.
   */
  const validateDeleteLevelTrd = (forms) => {
    let isLimitExcededMsg = "";
    let limitFormsToShow = 10;
    if (forms.length > limitFormsToShow) {
      isLimitExcededMsg = t("trd.delete.error1");
    }

    const newForms = forms.slice(0, 10);
    if (forms.length > 0) {
      swal({
        title: t("modal.DoneError.header"),
        text: `${t("trd.delete.error")} : ${"\n"}
        ${"\n"} ${newForms.map((form) => form.name).join("\n")} ${isLimitExcededMsg}`,
        icon: "error",
        dangerMode: true,
        button: t("modal.Done.footerButton"),
      });
    }
  };

  return (
    <TrdContext.Provider
      value={{
        getTreeByDomainCallback,
        getTreeByDomainCallbackRoles,
        levelFolder,
        setLevelFolder,
        fundName,
        setFundName,
        structureTrd,
        setStructureTrd,
        reStructureData,
        showRightPanel,
        setShowRightPanel,
        trdForm,
        setTrdForm,
        showFolderCondition,
        setShowFolderCondition,
        foldersId,
        setFoldersId,
        parentData,
        setParentData,
        showFormConditional,
        setShowFormConditional,
        showEditBackground,
        setShowEditBackground,
        showEditSection,
        setShowEditSection,
        showCreateSection,
        setShowCreateSection,
        editBackground,
        setEditBackground,
        createExpedientForm,
        setCreateExpedientForm,
        showCreateExpedientForm,
        setShowCreateExpedientForm,
        validateSerieinSubserie,
        selectLevel,
        setSelectLevel,
        isCreateExpedient,
        setIsCreateExpedient,
        createSubDivisionForm,
        setCreateSubDivisionForm,
        showCreateSubDivisonForm,
        setShowCreateSubDivisonForm,
        showCreateDirectoryForm,
        setShowCreateDirectoryForm,
        createDirectoryForm,
        setCreateDirectoryForm,
        currentLevelSelected,
        setCurrentLevelSelected,
        setIsLoading,
        isLoading,
        showExpedientTree,
        setShowExpedientTree,
        structureTrdExpedient,
        setStructureTrdExpedient,
        getTreeExpedientByDomainCallback,
        getTreeExpedientByDomainCallbackRoles,
        expedientName,
        setExpedientName,
        showRightPanelTreeExpedients,
        setShowRightPanelTreeExpedients,
        expedientParent,
        setExpedientParent,
        isByRecord,
        setIsByRecord,
        submitByRecord,
        setSubmitByRecord,
        folderName,
        setFolderName,
        showDirectoryCondition,
        setShowDirectoryCondition,
        option,
        setOption,
        optionEdit,
        setOptionEdit,
        editSubDivisionForm,
        setEditSubDivisionForm,
        showEditSubDivisonForm,
        setShowEditSubDivisonForm,
        optionDisabled,
        setOptionDisabled,
        showEditDirectoryForm,
        setShowEditDirectoryForm,
        editDirectory,
        setEditDirectory,
        editDirectoryForm,
        setEditDirectoryForm,
        optionDir,
        setOptionDir,
        showEditSectionForm,
        setShowEditSectionForm,
        showEditSerieForm,
        setShowEditSerieForm,
        showEditSubSectionForm,
        setShowEditSubSectionForm,
        openOptions,
        setOpenOptions,
        showEditSubSerieForm,
        setShowEditSubSerieForm,
        editSectionFormService,
        setEditSectionFormService,
        editSubSectionFormService,
        setEditSubSectionFormService,
        editSerieFormService,
        setEditSerieFormService,
        recordShowExpTree,
        setRecordShowExpTree,
        hasFiles,
        setHasFiles,
        getExpedientsBySearch,
        getExpedientsBySearchRoles,
        listExpedients,
        nodataMessage,
        totalPages,
        loadingExpedientList,
        errorCharacters,
        setErrorCharacters,
        searchData,
        setSearchData,
        status,
        setStatus,
        showOrdenation,
        setShowOrdenation,
        getSeriesSubseriesStructure,
        structureTrdSeriesSubseries,
        setStructureTrdSeriesSubseries,
        isStructure,
        setIsStructure,
        createSubDivisionFormSTR,
        setCreateSubDivisionFormSTR,
        seieSubserieId,
        setSeieSubserieId,
        seieSubserieBackgroundId,
        subDivisionId,
        setSubDivisionId,
        setSeieSubserieBackgroundId,
        validateField,
        setValidateField,
        createDirectoryFormSTR,
        setCreateDirectoryFormSTR,
        editSubDivisionFormSTR,
        setEditSubDivisionFormSTR,
        editDirectoryFormSTR,
        setEditDirectoryFormSTR,
        hasSubseries,
        setHasSubseries,
        hasExpedients,
        setHasExpedients,
        expedientParentByPath,
        setExpedientParentByPath,
        foldersIdByPath,
        setFoldersIdByPath,
        validateDeleteLevelTrd,
        paginationRecordList,
        setPaginationRecordList,
        refreshDataExpedient,
        setRefreshDataExpedient,
        getHasExpedientStructure,
        hasExpedientFixedPath,
        sethasExpedientFixedPath,
        expedientSetPath,
        setExpedientSetPath,
        isLoadingExpedietnPath,
        setIsLoadingExpedietnPath,
        expedientPathSet,
        setExpedientPathSet,
        expedientFixedUuid,
        setExpedientFixedUuid,
        isLoadingOrdination,
        hasOrdination,
        expedientStatus,
        backgroundUuid,
        setBackgroundUuid,
        dropdownPermissionsOpen,
        setDropdownPermissionsOpen,
        levelTrdPermissions,
        setLevelTrdPermissions,
        levelPermisionState,
        setLevelPermissionState,
        toggleDropdownPermissions,
        handleOnChangeLevelPermissions,
        handleAddLevelPermissions,
        temporalLevelTrdPermissions,
        setTemporalLevelTrdPermissions,
        handleRemoveLevelPermissions,
        toastlevelsTrd,
        isLoadingAddLevelsPermissions,
        handleOnSubmitLevelsPermissions,
        isFinishExpedientConfig,
        setIsFinishExpedientConfig,
        codeAlowedLevelsPermissions,
        codeAlowedExpedientLevelsPermissions,
        codeAlowedOrdinationLevelsPermissions,
      }}
    >
      {children}
    </TrdContext.Provider>
  );
}

TrdContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export function useTrdContext() {
  const context = React.useContext(TrdContext);
  if (!context) {
    throw new Error("useTrdContext must be inside the TrdContext provider.");
  }
  return context;
}
